export const isSafariBrowser = () => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return false;
  const ua = navigator.userAgent;
  // Exclude Chromium-based browsers
  return /Safari/i.test(ua) && !/Chrome|CriOS|Edg|Android/i.test(ua);
};

/**
 * Finds the scrollable container by walking up the DOM tree and scrolls to the top.
 * Useful for scrolling to the top of a modal/dialog when validation fails.
 */
export const scrollToTopOfScrollableContainer = (startElement: Element | null) => {
  if (!startElement) return;

  // Find the scrollable container by walking up the DOM tree
  let scrollableContainer: Element | null = startElement;
  while (scrollableContainer && scrollableContainer !== document.body) {
    const style = window.getComputedStyle(scrollableContainer);
    const isScrollable = style.overflowY === 'auto' || style.overflowY === 'scroll';
    const hasScroll = scrollableContainer.scrollHeight > scrollableContainer.clientHeight;

    if (isScrollable && hasScroll) {
      break;
    }
    scrollableContainer = scrollableContainer.parentElement;
  }

  if (scrollableContainer && scrollableContainer !== document.body) {
    scrollableContainer.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
